import { Box, useMediaQuery } from '@material-ui/core';
import useScrollToTop from 'Hook/useToTop';
import useWindowFocus from 'Hook/useWindowClick';
import KeepaEnLogo from 'assets/img/LogoEnColor4.png';
import SplashScreen from 'components/SplashScreen';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import RouterApp from 'router/Router';

const ImageKit = React.lazy(() => import('components/Image'));
const OnBoarding = React.lazy(() => import('pages/OnBoarding/OnBoarding'));
const SplashServerError = React.lazy(() => import('pages/SplashError/SplashServerError'));

function App() {
	const { visitOnboaeding } = useSelector((state) => state.storeSlice);
	const applicationStatus = useSelector((state) => state.connection?.stateConnection?.app?.status);
	const [isLoading, setIsLoading] = React.useState(true);
	const { pathname } = useLocation();

	useScrollToTop();

	useWindowFocus(setIsLoading);
	const matches = useMediaQuery('(min-width:480px)');
	const isLogoView = useMediaQuery('(min-width:1000px)');

	if (isLoading) {
		return (
			<div {...(matches && { id: 'mobile-view' })}>
				<SplashScreen />;
			</div>
		);
	} else {
		return (
			<Box>
				<div {...(matches && { id: 'mobile-view' })}>
					{!pathname.includes('walletrequest') && !applicationStatus ? (
						<React.Suspense fallback={<SplashScreen />}>
							<SplashServerError />
						</React.Suspense>
					) : (
						<>
							{visitOnboaeding ? (
								<React.Suspense fallback={<SplashScreen />}>
									<OnBoarding />
								</React.Suspense>
							) : (
								<RouterApp />
							)}
						</>
					)}
				</div>

				{matches && isLogoView && (
					<Box position={'fixed'} right="10%" bottom="5%">
						<React.Suspense fallback={<></>}>
							<ImageKit src={KeepaEnLogo} alt="logo" width="149px" height="60px" />
						</React.Suspense>
					</Box>
				)}
			</Box>
		);
	}
}
export default App;
